export const ACCOUNT_GROUP_OPTIONS = [
  {
    label: 'Tiếp nhận',
    value: 'Receptionist'
  },
  {
    label: 'Bác sĩ',
    value: 'Doctor'
  },
  {
    label: 'Dược sĩ',
    value: 'Pharmacist'
  },
  {
    label: 'Kế toán',
    value: 'Accountant'
  },
  {
    label: 'Kho',
    value: 'Warehouse'
  },
  {
    label: 'Admin',
    value: 'Admin'
  }
]

export const ACCOUNT_MAMAGERMENT_OPTIONS = [
  { label: 'Thông tin phòng khám', value: 'clinic_info' },
  { label: 'Tài khoản', value: 'manage_user' },
  { label: 'Phân quyền', value: 'permission' },
  { label: 'Thiết lập hệ thống', value: 'system_config' }
]

export const CATEGORY_MANAGEMENT = [
  { label: 'Nhóm dịch vụ', value: 'group' },
  { label: 'Dịch vụ', value: 'services' },
  { label: 'Thiết lập thời gian', value: 'timing' },
  { label: 'Bác sĩ', value: 'doctor' },
  { label: 'Thiết lập phòng khám', value: 'clinic' }
]

export const PATIENT_MAMAGERMENT_OPTIONS = [
  { label: 'Lịch hẹn', value: 'booking' },
  { label: 'Bệnh nhân', value: 'patient' },
  { label: 'Thanh toán', value: 'payment' },
  { label: 'Giao dịch', value: 'transaction' }
]

export const EXAMINATION_OPTIONS = [
  { label: 'Khám bệnh', value: 'examination' }
]
export const REPO_MANAGEMENT_OPTIONS = [
  { label: 'Tồn kho', value: 'inventory' },
  { label: 'Nhập kho', value: 'goods_receipt' }
]
